// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"2c4012ee","134":"512b5053","162":"e0b7e029","231":"f7969ecc","453":"68693753","549":"9fe7498d","577":"274cac2c","579":"3659290e","920":"75e06402"}[chunkId] + ".chunk.js";
};